import { useContext } from 'react';

import { PayloadContext } from './payload';

const usePayload = () => {
  const context = useContext(PayloadContext);

  if (!context) {
    throw new Error('Please use PayloadProvider in parent component');
  }

  return context;
};

export default usePayload;
